module.exports = __webpack_public_path__ + "img/paystack.58bfa8ea.svg";